import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-100">
        <Loader2 className="h-8 w-8 animate-spin text-orange-600" aria-hidden="true" />
        <span className="sr-only">Loading</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
